import { Grid, Typography } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { AsyncSelect, ControlledDatePicker } from "src/components/forms";
import CardActions from "src/pages/sistema/components/CardActions";
import { FormOperacionContraparte, OperacionContraparte } from "../types/types";
import { useOperacion } from "src/pages/sistema/hooks/useOperacion";
import { OperacionContraparteFields } from "../types/fields";
import { HttpCacheOperacion } from "src/pages/sistema/api/httpCacheOperacion";
import { dateFormatter } from "src/utils/formatters";
import {SectorComercialFields} from "../../../../../types";
import {SistemaTipo} from "../../../../../types/enum/enum";
import {useSectoresComerciales} from "../../../../messages/api/useSectoresComerciales";
import {useLoadOptions} from "../../../../../hooks/useLoadOptions";

type DatosOperacionProps = {
    formMethods: UseFormReturn<FormOperacionContraparte>
    readOnly?: boolean
    operacion?: OperacionContraparte
    codSistemaPrincipal: number
    codSistema: number
    nuevo?: boolean
}

const SeccionContraparteDatosOperacion = ({ formMethods, readOnly, operacion, codSistemaPrincipal, codSistema, nuevo }: DatosOperacionProps) => {
    const { control, watch } = formMethods

    const sectoresHook = useSectoresComerciales(codSistema)

    const loadSectoresComerciales = useLoadOptions({
        data: sectoresHook.sectores,
        loading: sectoresHook.loading,
        isError: sectoresHook.isError,
        error: sectoresHook.error
    });

    return (
        <CardActions title='Datos Operación' colapsable>
            <Grid container spacing={4}>
                {
                    !nuevo &&
                    <Grid item xs={12} md={3}>
                        <Typography variant='body2'>Usuario Alta</Typography>
                        <Typography>{operacion && `${operacion.nombreUsuarioAlta} ${operacion.apellidoUsuarioAlta}`}</Typography>
                    </Grid>
                }
                <Grid item xs={12} md={3}>
                    {
                        readOnly ?
                            <>
                                <Typography variant='body2'>Fecha Aprobación</Typography>
                                <Typography>{operacion ? dateFormatter.toShortDate(operacion?.fechaAprobacion) : '-'}</Typography>
                            </> :
                            <ControlledDatePicker
                                name={OperacionContraparteFields.FechaAprobacion}
                                label='Fecha Aprobación'
                                control={control}
                                selectedSections={undefined}
                                onSelectedSectionsChange={console.log}
                                fullWidth
                                readOnly={readOnly}
                            />
                    }
                </Grid>
                <Grid item xs={12} md={3}>
                    {
                        readOnly ?
                            <>
                                <Typography variant='body2'>Fecha Vencimiento</Typography>
                                <Typography>{(operacion && operacion?.fechaVencimiento) ? dateFormatter.toShortDate(operacion?.fechaVencimiento) : '-'}</Typography>
                            </> :
                            <ControlledDatePicker
                                name={OperacionContraparteFields.FechaVencimiento}
                                label='Fecha Vencimiento'
                                control={control}
                                selectedSections={undefined}
                                onSelectedSectionsChange={console.log}
                                fullWidth
                                minDate={watch(OperacionContraparteFields.FechaAprobacion)}
                                readOnly={readOnly}
                            />
                    }
                </Grid>
                <Grid item xs={12} md={3}>
                    {
                        readOnly ?
                            <>
                                <Typography variant='body2'>Sector Comercial</Typography>
                                <Typography>{operacion?.nombreSectorComercial}</Typography>
                            </> :
                            <AsyncSelect
                                control={control}
                                name={OperacionContraparteFields.CodSectorComercial}
                                label='Sector Comercial'
                                loadOptions={loadSectoresComerciales}
                                valueField={SectorComercialFields.SectorComercialCodigo}
                                fullWidth
                            />
                    }
                </Grid>
            </Grid>
        </CardActions>
    )
}

export default SeccionContraparteDatosOperacion
